import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Services } from './components/Services';
import { ReviewGrid } from './components/ReviewGrid';
import { Pricing } from './components/Pricing';
import { Team } from './components/Team';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-gameu-base text-gameu-text selection:bg-gameu-accent selection:text-gameu-base" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problems data-id="element-4" />
        <Services data-id="element-5" />
        <ReviewGrid data-id="element-6" />
        <Pricing data-id="element-7" />
        <Team data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}